module.exports = __webpack_public_path__ + "img/PCT16.33e386f5.svg";